<template>
  <div>
    <div class="divButtonRigth">
      <!--<el-button type="primary" size="small" @click="openCustomHeaderDialog">自定义表头</el-button>-->
      <el-button type="primary" size="small" @click="_exportTable">导出</el-button>
      <el-button type="primary" size="small" @click="goBack()">返回</el-button>
    </div>
    <div style="display: none">
      <p class="totalDetail"><span style="font-weight: bold"> 汇总详情：</span>
        应付总金额：<span class="red">{{noticeInfo.needPay |moneyFilter}}</span>
        实付总金额：<span class="red">{{noticeInfo.factPay |moneyFilter}}</span>
        使用财务余额：<span class="red">{{noticeInfo.useBalance |moneyFilter}}</span>
        使用对公余额：<span class="red">{{noticeInfo.usePubBalance |moneyFilter}}</span>
      </p>
    </div>
    <!--:copy-datas.sync = "copyDatas"-->
    <!--:change-data.sync = "changeData"-->
    <!--:change-arr.sync = "changeArr"-->
    <!--:sum-item.sync="sumItem"-->
    <bigTable
      ref="bigEdit"
      :names.sync="showColumn"
      :datas.sync="bigDatas"
      :isUpdate.sync="isUpdate"
      refname="bigTable"
      :cost-center-list="costCenterList"
      :pub-org-id-list.sync="pubOrgIdList"
      :amount-columns="amountColumns"
    >
    </bigTable>

    <!--<el-dialog v-dialogDrag
      ref="customHeader"
      id="dialog1"
      class="dialogWidth"
      custom-class="zidingyi"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="自定义表头"
      :visible.sync="customHeaderDialogVisiable"
    >-->
      <customHeader v-if="customHeaderDialogVisiable" :templateId.sync="templateId" :headerList.sync="allColumn" @refresh-column="this.refreshColumn"></customHeader>
<!--    </el-dialog>-->
  </div>
</template>

<script>
  import bigTable from "./dataImportTable"
  import customHeader from "./SalaryCustomHeader"

  import {getSalaryHeaders,getBillSalaryDetailList,exportNoticeDetail } from  "@/api/biz/salaryBatchInfo"
  import {getNoticeInfo,getCostCenterList} from "@/api/biz/bill/pay-notice"
  import {queryPubOrgList} from "@/api/orig-biz/pub-org-account"

  import { downloadFile } from '@/util/util';

  import {mapGetters} from 'vuex';
  let that;
  export default {
    name: "batchDetailList",
    components:{
      bigTable,
      customHeader
    },

    watch:{
    },
    data(){
      return {
        customHeaderDialogVisiable: false,
        noticeId:this.$route.query.noticeId,
        // templateId: this.$route.query.templateId,
        templateId: null,//this.$route.query.templateId,
        viewType: this.$route.query.viewType,
        allColumn:[], //所有表头
        showColumn:[], //显示表头
        copyDatas:[],
        bigDatas:[],
        changeData:[],
        changeArr:[],
        costCenterList:[],
        noticeInfo:{
          needPay:null,
          factPay:null,
          useBalance:null,
          usePubBalance:null,
          cusName:null,
          cusId:null,
        },
        // sumItem:[],
        pubOrgIdList:[],
        expObj:{
          noticeId:this.$route.query.noticeId,
          templateId: '',
          pubOrgIdList:[],
          costCenterList:[],
        },
        amountColumns:[],
        isUpdate:false,
      }
    },
    created(){
      const that = this;
      this.getBillInfo();
      // this._getimportHeader()
      that._getimportList()

    },
    filters: {
      getCusName(cusId){
        return  that.noticeInfo.cusName;
      },
    },
    beforeCreate(){
      that =this
    },
    mounted(){
    },
    methods:{
      getBillInfo(){
        getNoticeInfo(this.noticeId).then(res => {
          this.noticeInfo.needPay=res.data.needPay;
          this.noticeInfo.factPay=res.data.factPay;
          this.noticeInfo.useBalance=res.data.useBalance;
          this.noticeInfo.usePubBalance=res.data.usePubBalance;
          this.noticeInfo.cusName=res.data.cusName;
          this.noticeInfo.cusId=res.data.cusId;
          this.templateId=res.data.salaryBatchInfoMap[0].salaryTemplateId;
          this.getCostCenterList();
          this._getimportHeader();
        })
      },
      getCostCenterList(){
        getCostCenterList(this.noticeInfo.cusId).then(res => {

          if(res.data.code==0){
            this.costCenterList=res.data.data;
          }
        });
        queryPubOrgList().then(res => {
          if(res.data.code==0) {
            this.pubOrgIdList = res.data.data;
          }
        });
      },

      //获取表头数据
      _getimportHeader: function() {
        const that = this;
        let i=0;
        getSalaryHeaders(that.templateId,this.noticeId,null,that.noticeInfo.cusId).then(res => {
          let rs=res.data
          this.allColumn=rs.data
          this.allColumn.forEach((item) => {
            // if(item.editRender&&item.editRender.name === "input"){
            //   item.editRender.events = {blur: this.changeEvent}
            //     item.editRender.immediate = true
            // }
            if(item.editRender){
              item.editRender = null;
            }
            if(item.valueType=='6'){
              // item.formatter = "formatCode";
            }
            if(item.valueType=='2'&& item.show==true){
              // item.formatter = this.$options.filters['moneyFilter'];
              // that.sumItem[i]=item.field;
              that.amountColumns.push(item.field)
              i++;
            }
            if(item.field=='cusId'){
              // item.formatter = this.$options.filters['getCusName'];//"getCusName";
              item.slots = {default: 'cusId'}
            }
            if(item.field=='costCenter'){
              item.slots = {default: 'costCenter'}
            }
            if(item.field=='trusteeOrgId'){
              item.slots = {default: 'trusteeOrgId'}
            }
            if (item.field === "empName") {
              item.slots = {default: 'empName'}
            }
          })
          that.showColumn=this.filterIsShowHeaders(rs.data)
        }).catch(()=>{
        })
      },
      // 过滤掉不显示的表头
      filterIsShowHeaders: function(headerList){
        let arr = headerList.filter(element=>element.show==true)
        arr.forEach(e=>{
          // 将雇员姓名与证件号码锁定
          if(e.field=='empName'||e.field=='identityNum'){
            e.fixed='left'
          }
        })
        arr.unshift( { type: 'seq',title:"序号", width: 50, show:true ,fixed: 'left'})
        return arr
      },
      refreshColumn: function(headerList){
        this.showColumn=this.filterIsShowHeaders(headerList)
      },
      //获取列表数据
      _getimportList: function() {
        const that = this;
        getBillSalaryDetailList(that.noticeId).then(res => {
          that.$set(that,"bigDatas",JSON.parse(JSON.stringify(res.data.data)))
          that.$set(that,"copyDatas",JSON.parse(JSON.stringify(res.data.data)))
        }).catch(()=>{
        })
      },

      _exportTable(){

        let parmes = {
          id:this.expObj.noticeId,
          isOtherBiz:false,
          contractType:'',
          contractCode:'',
          cusId:that.noticeInfo.cusId
        }
        exportNoticeDetail(parmes).then(res=>{
          downloadFile(res);
        })
      },

      // 打开自定义表头dialog
      openCustomHeaderDialog: function(){
        this.customHeaderDialogVisiable=true;
      },
      goBack(){
         this.$router.push({path:'/wage/payment'});
      },
      changeEvent ({ row, rowIndex, column, columnIndex }){
        // 如果值改变，将下标存入数组循环样式，将row存入数组用于保存
        if(this.copyDatas[rowIndex][column.property] !== row[column.property]){
          // 值
          let obj = {};
          obj.index = rowIndex;
          obj.data = row;
          let hasData = this.changeData.find((v) => {
            return v.index == rowIndex;
          });
          if(hasData){
            this.changeData.splice(this.changeData.indexOf(hasData),1)
          }
          this.changeData.push(obj)
          // index
          let hasChange = this.changeArr.find((v) => {
            return v.rowIndex === rowIndex
          });
          if(hasChange){
            if(!this.changeArr[this.changeArr.indexOf(hasChange)].columns.includes(columnIndex)){
              this.changeArr[this.changeArr.indexOf(hasChange)].columns.push(columnIndex)
            }
          }else{
            let item = {};
            item.rowIndex = rowIndex;
            item.columns =[];
            item.columns.push(columnIndex);
            this.changeArr.push(item)
          }
        }else{
          // 如果值等于原来的值，判断是否更改过，还原
          let hasData = this.changeData.find((v) => {
            return v.index == rowIndex;
          });
          if(hasData){
            this.changeData.splice(this.changeData.indexOf(hasData),1)
          }

          let hasChange = this.changeArr.find((v) => {
            return v.rowIndex === rowIndex
          });
          if(hasChange){
            this.changeArr[this.changeArr.indexOf(hasChange)].columns.splice([this.changeArr[this.changeArr.indexOf(hasChange)].columns.indexOf(columnIndex)],1)
            if(this.changeArr[this.changeArr.indexOf(hasChange)].columns.length === 0){
              this.changeArr.splice([this.changeArr.indexOf(hasChange)],1)
            }
          }
        }
        // 调用子页面方法
        this.$refs.bigEdit.$refs.bigTable.cellStyle({ row, rowIndex, column, columnIndex });
      },
    }
  };
</script>

<style scoped>
  .totalDetail{
    font-size: 13px;
    line-height: 2;
    margin-top: -10px;
  }
  .totalDetail span{
    margin-right: 10px;
    font-size: 14px;
  }
.red{
  color:red;
}
</style>
